var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"custom-checkbox",staticStyle:{"display":"flex","align-items":"flex-start","gap":"0px"}},[_c('v-checkbox',{attrs:{"type":"checkbox","on-icon":'$checked',"off-icon":'$uncheck',"hide-details":""},model:{value:(_vm.computedValue),callback:function ($$v) {_vm.computedValue=$$v},expression:"computedValue"}}),_c('span',{style:({
        'font-size': _vm.textSize
      }),domProps:{"innerHTML":_vm._s(_vm.label)}})],1),(_vm.errorMessages)?_c('span',{style:({
      'font-size': '13px',
      color: '#b71c1c'
    })},[_vm._v(" "+_vm._s(_vm.errorMessages)+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }